<template>
  <div
    :class="{ 'invisible': !isVisible}"
    class="systemNotification__wrapper"
  >
    <!--
      Порядок блоков обратен очереди: стопка растёт снизу вверх, и первое окно
      очереди должно оказаться ближе к нижнему краю экрана. Поэтому здесь
      сначала идёт последнее в очереди, а обновление — самым низким.
    -->
    <div
      v-if="shown('whatsNew')"
      class="systemNotification new-version"
    >
      <div class="systemNotification__body" v-html="$t('system.new_version_message')" />
      <div class="systemNotification__btn-row">
        <up-button
          class="systemNotification__btn btn-primary"
          @click="isLatter"
        >
        {{ $t('system.btn_show_later') }}
        </up-button>
        <up-button
          class="systemNotification__btn btn-primary"
          @click="IsShowed"
        >
        {{ $t('system.btn_close') }}
        </up-button>
      </div>
    </div>
    <div
      v-if="shown('push')"
      class="systemNotification"
    >
      <push-ask @close="$emit('close-push-ask')" />
    </div>
    <div
      v-if="shown('install')"
      class="systemNotification"
    >
      <install-pwa
        @install-pwa="installPwa(true)"
        @decline-pwa="installPwa(false)"
      />
    </div>
    <div
      v-if="shown('update')"
      class="systemNotification"
    >
      <update-pwa
        :updatePwaExist="updatePWAExist"
        @update-pwa="updatePWA(true)"
        @denied-update-pwa="updatePWA(false)"
      />
    </div>
  </div>
</template>
<script>
import mixinUpdatePwa from '@/components/mixins/methodsPwaUpdate';
import updatePwa from './updatePwa.vue';
import installPwa from './installPwa.vue';
import pushAsk from './pushAsk.vue';

/** Больше двух карточек разом закрывают пол-экрана. Остальные ждут очереди. */
const MAX_VISIBLE = 2;

export default {
  name: 'systemNotification',
  mixins: [mixinUpdatePwa],
  components: { updatePwa, installPwa, pushAsk },
  emits: ['close-push-ask'],
  props: {
    isDropLocalNotification: {
      type: Boolean,
      default: false,
    },
    pushAskExist: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLocalSystemNotification: false,
      showLatter: true,
      showLatterTimeout: null,
    };
  },
  computed: {
    /**
     * Очередь системных окон.
     *
     * Обновление вытесняет всё остальное: оно всё равно кончается перезагрузкой,
     * и предлагать на её фоне что-то ещё бессмысленно.
     *
     * Дальше порядок по смыслу: установка на экран идёт перед подпиской, потому
     * что на iOS без установки push не работает физически. «Что нового» —
     * последним, оно самое несрочное.
     */
    queue() {
      if (this.updatePWAExist) return ['update'];

      return [
        ['install', this.installPwaExist],
        ['push', this.pushAskExist],
        ['whatsNew', this.isVisibleNotification],
      ]
        .filter(([, visible]) => visible)
        .map(([id]) => id);
    },
    visibleCards() {
      return this.queue.slice(0, MAX_VISIBLE);
    },
    isVisible() {
      return this.visibleCards.length > 0;
    },
    // По ссылке окно не показываем до перезагрузки — см. docs/deep-links.md
    isVisibleNotification() {
      // eslint-disable-next-line max-len
      return this.showLatter && this.isLocalSystemNotification !== false && !this.updatePWAExist
        && !this.$store.getters.isNoticeHiddenByLink;
    },
  },
  mounted() {
    if (this.isDropLocalNotification) {
      localStorage.removeItem('isLocalNotification');
    }
    const IS_LOCAL_NOTIFICATION = localStorage.getItem('isLocalNotification');
    this.isLocalSystemNotification = IS_LOCAL_NOTIFICATION === null || IS_LOCAL_NOTIFICATION !== 'isShowed';
  },
  methods: {
    shown(id) {
      return this.visibleCards.includes(id);
    },
    isLatter() {
      if (this.showLatterTimeout) {
        this.removeTimeout();
      }
      this.showLatter = false;
      this.showLatterTimeout = setTimeout(() => {
        this.showLatter = true;
      }, 120000000);
    },
    IsShowed() {
      localStorage.setItem('isLocalNotification', 'isShowed');
      this.isLocalSystemNotification = false;
    },
    removeTimeout() {
      clearTimeout(this.showLatterTimeout);
    },
  },
  beforeUnmount() {
    if (this.showLatterTimeout) {
      this.removeTimeout();
    }
  },
};
</script>
<style lang="scss">
.systemNotification {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  max-width: 760px;
  gap: 6px;
  padding: 12px 16px;
  background: #FFFEFB;
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.25);
  border-radius: 16px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px;
    gap: 4px;

    &.invisible {
      display: none;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    align-items: start;
    gap: 10px;
  }
  &.new-version {
    max-height: 60vh;
    overflow: hidden auto;
    padding-bottom: 0;
    i {
      font-size: 1.1rem;
      &.big-i {
        font-size: 1.4rem;
      }
      &.exu-user-meeting {
        color: #2D3038;
      }
      &.exu-bookmark, &.exu-msg-question-sq {
        color: #FCB136;
      }
    }
    .systemNotification__btn {
      &-row {
        position: sticky;
        bottom: 0;
        margin: 0 -12px ;
        padding: 0 12px 16px;
        background: rgba(250,250,250,.75);
      }
    }
  }

  .notification-title {
    color: #2D3038;
    &.title-accent {
      color: #2D3038;
      font-weight: 700;
    }
  }

  .systemNotification__btn {
    text-decoration: none;
    font-size: 1rem;
    padding: 10px 6px;

    &-row {
      display: flex;
      gap: 12px;
    }

    &.btn-primary {
      border-color: #2D3038;
      color: #2D3038;
    }
    &.btn-success {
      border-color: #FCB136;
      color: #2D3038;
    }
    &.btn-success-fill {
      background: #FCB136;
      color: #2D3038;
    }
    &.btn-decline {
      border-color: #95969D;
      color: #95969D;
    }
    &.btn-large {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0 25px;
      border-radius: 25px;
      text-align: center;
      font-weight: 700;
      width: 100%;
    }

    // @media (min-width: 350px) {
    //   & {
    //     font-size: 1.2rem;
    //     padding: 10px;
    //   }
    // }
  }
  .badge {
    background: #eef2f5;
    color: #1a2b3c;
    font-size: 14px;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 30px;
    display: inline-block;
    margin-bottom: 20px;
  }
}
</style>
